import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  container: {
    padding: 8
  },
  select: {
    display: 'flex',
    padding: 10,
    borderRadius: 6,
    cursor: 'pointer',
    '&:hover': {
      background: '#f7f7f8'
    }
  },
  label: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: 400
  },
  sectionTitle: {
    color: '#6A728F',
    fontSize: 12,
    marginTop: 4,
    marginLeft: 12,
    marginBottom: 10
  }
}));

type State = {
  allComplete: boolean;
  sixMonths: boolean;
  threeMonths: boolean;
  incompleteCourse: boolean;
  hasExpiredDocument: boolean;
  hasActiveDocument: boolean;
  hasActiveBackgroundCheck: boolean;
  hasExpiredBackgroundCheck: boolean;
};

type Props = {
  onChange?: (state: State) => void;
  state: State;
};

export default function DelegatesFilterOptions({ state, onChange }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.sectionTitle}>FILTER</div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: !state.allComplete,
              sixMonths: false,
              threeMonths: false,
              incompleteCourse: false,
              hasExpiredDocument: false,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.allComplete} />
        <div className={classes.label}>All courses completed</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: false,
              threeMonths: false,
              incompleteCourse: !state.incompleteCourse,
              hasExpiredDocument: false,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.incompleteCourse} />
        <div className={classes.label}>Has incomplete course</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: !state.sixMonths,
              threeMonths: false,
              incompleteCourse: false,
              hasExpiredDocument: false,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.sixMonths} />
        <div className={classes.label}>Expiring in 6 months</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: false,
              threeMonths: !state.threeMonths,
              incompleteCourse: false,
              hasExpiredDocument: false,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.threeMonths} />
        <div className={classes.label}>Expiring in 3 months</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: false,
              threeMonths: false,
              incompleteCourse: false,
              hasExpiredDocument: !state.hasExpiredDocument,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.hasExpiredDocument} />
        <div className={classes.label}>Has expired document</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: false,
              threeMonths: false,
              incompleteCourse: false,
              hasExpiredDocument: false,
              hasActiveDocument: !state.hasActiveDocument,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.hasActiveDocument} />
        <div className={classes.label}>Has active document</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: false,
              threeMonths: false,
              incompleteCourse: false,
              hasExpiredDocument: false,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: !state.hasActiveBackgroundCheck,
              hasExpiredBackgroundCheck: false
            });
        }}
      >
        <input type="checkbox" checked={state.hasActiveBackgroundCheck} />
        <div className={classes.label}>Has valid background check</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              allComplete: false,
              sixMonths: false,
              threeMonths: false,
              incompleteCourse: false,
              hasExpiredDocument: false,
              hasActiveDocument: false,
              hasActiveBackgroundCheck: false,
              hasExpiredBackgroundCheck: !state.hasExpiredBackgroundCheck
            });
        }}
      >
        <input type="checkbox" checked={state.hasExpiredBackgroundCheck} />
        <div className={classes.label}>Has expired background check</div>
      </div>
    </div>
  );
}
